import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";

/**
 * @Description this page Dictionary Library's Put Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Update({
  action,
  variables,
  setOpenVariable,
  variableRender,
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.DICTIONARY.";

  return (
    <div>
      <div className="form-element">
        {t(label + "DICTIONARY-VARIABLE")}
        <VariablePicker
          action={action}
          inputName="dictionaryVariable"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          isRequired={true}
          filter="dictionary"
        />
        <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'dictionary' })}</em></small>
      </div>
      <div className="form-element">
        {t(label + "ASSOCIATE-KEY")}
        <TextInput
          action={action}
          inputName="key"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
        />
      </div>
      <div className="form-element">
        {t(label + "NEW-VALUE")}
        <TextInput
          action={action}
          inputName="newValue"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
        />
      </div>
      <div className="form-element">
        {t(label + "ASSIGN-PREVIOUS-VARIABLE")}
        <VariablePicker
          action={action}
          inputName="set"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          isRequired={true}
        />
      </div>
    </div>
  );
}
